import React from "react";

function DashboardAdmin() {
  return (
    <div className="container mt-5">
      <h2>Admin Dashboard</h2>
      <p>Welcome, Admin! Manage users and data here.</p>
    </div>
  );
}

export default DashboardAdmin;